var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "background",
    style: {
      fill: "#0f0",
      stroke: "#0f0",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C8 0 0 11 0 16C0 20.3984 3.60156 24 8 24C12.3984 24 16 20.3984 16 16C16 10.6992 8 0 8 0ZM5 16.1992C5 19.6992 6.5 21 6.5 21C6.5 21 3 20.1016 3 15.3008C3 12 7 5 7 5C7 5 5 11.1016 5 16.1992Z",
    fill: "#36c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHighlight);
export default __webpack_public_path__ + "static/media/WaterHighlight.d32ee23ab117c1e947176bac589ff152.svg";
export { ForwardRef as ReactComponent };